import sha1 from "crypto-js/sha1"
import Hex from "crypto-js/enc-hex"
import Config from "../Config"
import { Participant, hasExpectedData } from "../Participant"
import { UploadJson } from "../Upload"

export function getPreset(
  code: string,
  successCallback: (json: any) => void,
  errorCallback: (errorMessage: string) => void,
) {
  getJson(
    `${process.env.REACT_APP_API_BASE_URL}api/presets/by-code/${code}?expand[]=layout-groups`,
    successCallback,
    errorCallback,
  )
}

export function getUpload(
  code: string,
  successCallback: (uploadJson: UploadJson) => void,
  errorCallback: (errorMessage: string) => void,
) {
  getJson(
    `${process.env.REACT_APP_API_BASE_URL}api/uploads/${code}`,
    successCallback,
    errorCallback,
  )
}

export function upload(
  config: Config,
  sessionId: string,
  compositeImage: string,
  rawFrame: string,
  isPublic: boolean,
  participant: Participant | null,
  completion: (response: any) => void,
) {
  let hashStr = Hex.stringify(sha1(compositeImage))

  // TODO: Provide more granular data starting with config edit tool list
  let specialEffects = { virtual_booth: true }

  let params: any = {
    app_token: {
      token: "",
      timestamp: "1589390640",
    },
    data: {
      session_id: sessionId,
      preset_id: config.presetId,
      public: isPublic,
      raw_frames: ["frame1"],
      frame_count: 1,
      format_info: {
        filter: 0,
        gif_speed: "fast",
        layout: "1x1",
        frame_rotation: "",
        logo_position: "none",
        bg_color: "white",
        margin_percent: 0,
        crop: config.captureAspectRatio === "1:1" ? "square" : "none",
        roundness_percent: 0,
        special_effects: specialEffects,
      },
      image_hash: hashStr,
    },
  }

  if (participant !== null) {
    params.data.participant = {}
    if (config.dataCapture.emailOn) {
      params.data.participant.email = participant.email
    }
    if (config.dataCapture.firstNameOn) {
      params.data.participant.firstName = participant.firstName
    }
    if (config.dataCapture.lastNameOn) {
      params.data.participant.lastName = participant.lastName
    }
    if (config.dataCapture.phoneNumberOn) {
      params.data.participant.phoneNumber = participant.phoneNumber
    }
  }

  const formData = new FormData()
  appendToFormData(formData, params)
  formData.append("frame1", b64toBlob(rawFrame), "frame1.jpg")
  formData.append("upload", b64toBlob(compositeImage), "upload.jpg")

  let headers = new Headers({
    "X-User-Agent": "Virtual Booth/1.1",
  })

  fetch(process.env.REACT_APP_API_BASE_URL + "api/upload/image", {
    method: "POST",
    headers: headers,
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`${response.status} error`)
      }

      return response.json()
    })
    .then((json) => completion(json.data))
    .catch((error) => completion(error))
}

export function checkProcessedStatus(uploadId: number, completion: (isProcessed: boolean) => void) {
  fetch(`${process.env.REACT_APP_API_BASE_URL}api/uploads/${uploadId}/processed`, {
    method: "GET",
  })
    .then((response) => response.json())
    .then((isProcessed) => completion(isProcessed))
}

export function getJson(
  url: string,
  successCallback: (json: any) => void,
  errorCallback: (errorMessage: string) => void,
) {
  fetch(url, { method: "get" })
    .then((response) => {
      if (!response.ok) {
        throw response
      }
      if (response.status === 204) {
        return null
      }
      return response.json()
    })
    .then((json) => {
      successCallback(json)
    })
    .catch((data) => {
      if (data instanceof TypeError) {
        errorCallback(data.message)
      } else {
        errorCallback(data.status + " error")
      }
    })
}

function appendToFormData(formData: FormData, data: any, parentKey?: string) {
  if (data && typeof data === "object" && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      appendToFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
    })
  } else if (parentKey) {
    formData.append(parentKey, data)
  } else {
    throw new Error("Data did not contain keys")
  }
}

export function b64toBlob(dataURI: string) {
  var byteString = atob(dataURI.split(",")[1])
  var ab = new ArrayBuffer(byteString.length)
  var ia = new Uint8Array(ab)

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], { type: "image/jpeg" })
}

export function b64toUint8Array(dataURI: string): Uint8Array {
  var byteString = atob(dataURI.split(",")[1])
  var ia = new Uint8Array(byteString.length)

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return ia
}
